import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,   // <-- Add this
} from "@material-ui/core";

import { useEffect, useState } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import axios from "../../../utils/axios";
import Swal from "sweetalert2";
import { useParams, useHistory } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Link } from "react-router-dom";
const FundTransferDetailsEdit = () => {
  const { id } = useParams();
  const history = useHistory();

  const [request, setRequest] = useState(null);
  const [banks, setBanks] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [reqRes, banksRes, beneRes] = await Promise.all([
          axios.get(`/fund-transfer-requests/${id}?eftType=General`),
          axios.get("/bank-bo/list-all/Cash"),
          axios.get("/beneficiaries/approved"),
        ]);

        if (reqRes.data.success) {
          setRequest(reqRes.data.payload);
        }
        if (banksRes.data.success) {
          setBanks(banksRes.data.payload);
        }
        if (beneRes.data.success) {
          setBeneficiaries(beneRes.data.payload);
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Unable to load data", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading || !request) return <p>Loading...</p>;

  // Handle bank selection change
  // const handleBankChange = (e) => {
  //   const selected = banks.find((b) => b.companyName === e.target.value);
  //   if (selected) {
  //     setRequest({
  //       ...request,
  //       bankBo: {
  //         ...request.bankBo,
  //         companyName: selected.companyName,
  //         accountNumber: selected.accountNumber,
  //         branch: selected.branch,
  //         address: selected.address,
  //       },
  //     });
  //   }
  // };

  // Beneficiary dropdown change
  const handleBeneficiarySelect = (index, beneficiaryId) => {
    const selected = beneficiaries.find((b) => b.id === beneficiaryId);
    if (!selected) return;

    const updated = [...request.details];
    updated[index] = {
      ...updated[index],
      beneficiary: selected,
    };
    setRequest({ ...request, details: updated });
  };

  // Handle generic input change
  const handleChange = (field, value) => {
    setRequest({ ...request, [field]: value });
  };

  // Handle bankBo field change
  const handleBankBoChange = (field, value) => {
    setRequest({
      ...request,
      bankBo: { ...request.bankBo, [field]: value },
    });
  };

  // Handle beneficiary amount change
  const handleAmountChange = (index, value) => {
    const updated = [...request.details];
    updated[index].amount = value;
    setRequest({ ...request, details: updated });
  };

  // Remove beneficiary row
  const handleRemoveBeneficiary = (index) => {
    const updated = [...request.details];
    updated.splice(index, 1);
    setRequest({ ...request, details: updated });
  };

  // Add beneficiary row
  const handleAddBeneficiary = () => {
    setRequest({
      ...request,
      details: [...request.details, { beneficiary: null, amount: "" }],
    });
  };

// Submit
const handleSubmit = async () => {
  try {
    // Build payload in the required structure
    const payload = {
      // refNo: request.refNo,
      date: request.date,
      subject: request.subject,
      primarySignatoryId: request.primarySignatory?.id,
      secondarySignatoryId: request.secondarySignatory?.id,
      bankBoId: request.bankBo?.id,
      details: request.details.map((d) => ({
        beneficiaryId: d.beneficiary?.id,
        amount: d.amount,
      })),
    };

    console.log("Submitting payload:", payload);

    const res = await axios.put(`/fund-transfer-requests/${id}`, payload);

    if (res.data.success) {
      Swal.fire("Success", "Fund Transfer Request updated", "success");
      history.push("/app/eft/fundTransferRequestList");
    }
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Unable to update request", "error");
  }
};


  return (
    <div>
      
            <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            style={{ marginBottom: "10px" }}
          >
            {/* Left side: title */}
            <Grid item>
              <PageTitle title="Edit Fund Transfer Request" />
            </Grid>

            {/* Right side: buttons in one line */}
            <Grid item>
              <Grid container spacing={2}>
                  <Grid item>
                  <Link to="/app/eft/fundTransferRequestList">
                       <Button variant="contained" color="primary">
                 Back
              </Button>
                  </Link>
                </Grid>
            
              </Grid>
            </Grid>
          </Grid>


      {/* Company Dropdown */}
      {/* <Box mb={2}>
        <Select
          fullWidth
          value={request.bankBo.companyName || ""}
          onChange={handleBankChange}
          //  InputLabelProps={{readOnly: true}}
        >
          {banks.map((bank) => (
            <MenuItem key={bank.id} value={bank.companyName}>
              {bank.companyName} 
            </MenuItem>
          ))}
        </Select>
      </Box> */}

        <Grid item xs={6}>
          <TextField
            label="Bank Name"
            fullWidth
            value={request.bankBo.companyName || ""}
            InputLabelProps={{readOnly: true}}
              disabled
            // onChange={(e) => handleChange("refNo", e.target.value)}
          />
        </Grid>

      {/* RefNo + Date */}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            label="Ref No"
            fullWidth
            value={request.refNo}
            InputLabelProps={{readOnly: true}}
              disabled
            // onChange={(e) => handleChange("refNo", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Date"
            type="date"
            fullWidth
            value={request.date}
            onChange={(e) => handleChange("date", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>

  {/* Bank Info */}
        {/* Bank Info */}
      <Box mt={1}>
        <Grid container spacing={2}>
          {/* Company Name */}
          <Grid item xs={12} md={4}>
            <TextField
              label="Company Name"
              fullWidth
              value={request.bankBo.companyName || ""}
              disabled
            />
          </Grid>

          {/* Account No */}
          <Grid item xs={12} md={4}>
            <TextField
              label="Account No"
              fullWidth
              value={request.bankBo.accountNumber || ""}
              disabled
            />
          </Grid>

          {/* Branch */}
          <Grid item xs={12} md={4}>
            <TextField
              label="Branch"
              fullWidth
              value={request.bankBo.branch || ""}
              disabled
            />
          </Grid>

          {/* Address on new line */}
          <Grid item xs={12}>
            <TextField
              label="Address"
              fullWidth
              value={request.bankBo.address || ""}
              disabled
            />
          </Grid>
        </Grid>
      </Box>


      {/* Subject */}
      <Box mt={1}>
        <TextField
          label="Subject"
          fullWidth
          value={request.subject}
          onChange={(e) => handleChange("subject", e.target.value)}
        />
      </Box>

      {/* Beneficiary Table */}
<Box mt={2} component={Paper} p={1}>
  <Typography variant="h6">Beneficiaries</Typography>

  <TableContainer>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Sl. No</TableCell>
          <TableCell>Beneficiary</TableCell>
          <TableCell>Bank</TableCell>
          <TableCell>Branch</TableCell>
          <TableCell>Account No</TableCell>
          <TableCell>Routing</TableCell>
          <TableCell>Amount (BDT)</TableCell>
          <TableCell>Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {request.details.map((detail, idx) => (
          <TableRow key={idx}>
            <TableCell>{idx + 1}</TableCell>

            {/* Beneficiary Autocomplete */}
            <TableCell style={{ minWidth: 320 }}>
              <Autocomplete
                fullWidth
               
                size="small"
                options={beneficiaries}
                getOptionLabel={(option) =>
                  `${option.name} - ${option.accountNo}`
                }
                value={
                  beneficiaries.find(
                    (b) => b.id === detail.beneficiary?.id
                  ) || null
                }
                onChange={(e, newValue) => {
                  if (newValue) {
                    handleBeneficiarySelect(idx, newValue.id);
                  }
                }}
                renderInput={(params) => (
                  <TextField
               
                    {...params}
                    variant="outlined"
                    size="small"
                    placeholder="Select Beneficiary"
                   
                  />
                )}
              />
            </TableCell>

            {/* Auto-filled fields */}
            <TableCell>{detail.beneficiary?.bank?.bankName || ""}</TableCell>
            <TableCell>{detail.beneficiary?.bank?.branchName || ""}</TableCell>
            <TableCell>{detail.beneficiary?.accountNo || ""}</TableCell>
            <TableCell>{detail.beneficiary?.bank?.routingNo || ""}</TableCell>

            {/* Editable Amount */}
            <TableCell>
              <TextField
                size="small"
                value={detail.amount || ""}
                onChange={(e) => handleAmountChange(idx, e.target.value)}
              />
            </TableCell>

            {/* Remove row */}
            <TableCell>
              <Button
                size="small"
                color="secondary"
                onClick={() => handleRemoveBeneficiary(idx)}
              >
                Remove
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>

  {/* Add Beneficiary Button */}
  <Box mt={1}>
    <Button
      variant="outlined"
      color="primary"
      onClick={handleAddBeneficiary}
    >
      + Add Beneficiary
    </Button>
  </Box>
</Box>


      {/* Submit */}
      <Box mt={1}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Update
        </Button>
      </Box>
    </div>
  );
};

export default FundTransferDetailsEdit;
